import { combineReducers } from "redux";
import MiniSitesReducers from "./MiniSitesReducers";
import RssCrawlResultReducers from "./RssCrawlResultReducers";
import BrokenUrlResultReducers from "./BrokenUrlResultReducers";
import CompaniesWithoutKeyContactsResultReducers from "./CompaniesWithoutKeyContactsResultReducers";
import IdentifySupplierJobsReducers from "./IdentifySupplierJobsReducers";

const rootReducer = combineReducers({
  MiniSitesReducers,
  RssCrawlResultReducers,
  BrokenUrlResultReducers,
  CompaniesWithoutKeyContactsResultReducers,
  IdentifySupplierJobsReducers,
});
export default rootReducer;
